/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import initialState from '../helpers/form-helpers/initial-state';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import { hasValue } from '../../../../../general/js/general-helpers';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import BallotSummaryDetailsFormData from './helpers/ballot-summary-form-data';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';
import { createDate } from '../../utils/date-utils';
import { MembershipTypes } from '../../../../../general/js/utils';

class BallotSummaryForm extends Component {
    constructor(props) {
        super(props);

        const { formData, ssoDomain } = this.props;

        const mainAddress = upgradeFormHelper.getMainAddress(formData.currentUser);
        const birthDate = upgradeFormHelper.getDateOfBirth(formData.currentUser);

        this.state = {
            ...initialState.upgradeBallotFormState,
            [formConstants.country]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.country),
            [formConstants.county]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.county),
            [formConstants.state]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.state),
            [formConstants.city]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.city),
            [formConstants.addressLine1]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine1),
            [formConstants.addressLine2]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine2),
            [formConstants.addressLine3]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine3),
            [formConstants.postcode]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.postcode),
            [formConstants.dateOfBirth]: birthDate ? createDate(birthDate.year, birthDate.month, birthDate.day) : null,
            ssoDomain,
            userDataLoaded: false,
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();
        this.formReferences = formScrollHelpers.getFormReferences(formData);

        this.displayBallotSummaryForm = this.displayBallotSummaryForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserUpdateBallotSummarySuccess = this.handleUserUpdateBallotSummarySuccess.bind(this);
        this.submitBallotSummaryData = this.submitBallotSummaryData.bind(this);
    }

    componentDidMount() {
        const { onSignIn, formData, actions } = this.props;

        if (isEmpty(formData)) {
            onSignIn();
        }

        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.BallotSummaryForm);

        const { userProfileCallbackUrl } = formData;
        actions.getUserAccountData(userProfileCallbackUrl, false);
    }

    componentWillReceiveProps(nextProps) {
        const {
            formData,
            isUpgradeSuccessful,
            loading,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful,
            isUserAccountDataLoadedSuccessful,
            userAccountData
        } = nextProps;

        const { userDataLoaded } = this.state;

        if (hasValue(formData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.BallotSummaryForm);
        }

        if (!loading && isUserAddressRetrieveSuccessful && !isUpgradeSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
            return;
        }

        if (!loading &&
            isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserUpdateBallotSummarySuccess);
            return;
        }

        if (!loading &&
            !isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }

        if (!loading && !isEmpty(userAccountData) &&
            isUserAccountDataLoadedSuccessful && !userDataLoaded) {
            this.updateUserAccountData(userAccountData);
        }
    }

    updateUserAccountData(nextUserAccountData) {
        const { formData } = this.props;

        const userAccountData = cloneDeep(nextUserAccountData);

        const userDetailsFormData = new BallotSummaryDetailsFormData(formData, userAccountData);

        if (userAccountData.membership.includes(MembershipTypes.OneClubAdvantage)) {
            userDetailsFormData.mastercard.isDisabled = true;
            userDetailsFormData.mastercard.label = formData.alreadyMastercardMemberText;
        }
        this.setState(formStateHelpers.updateFormFields(userDetailsFormData));

        this.setState(
            (prevState) => ({
                ...prevState,
                userDetailsFormData,
                userDataLoaded: true
            })
        );
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.upgradeAccountFormState);
        actions.resetUpgradeAccountFormState();
    }

    handleUserUpdateBallotSummarySuccess() {
        const {
            handleBallotSummarySuccess,
            formData,
            handleBallotPortalRedirect
        } = this.props;

        if (!hasValue(formData)) {
            handleBallotPortalRedirect();
        }

        handleBallotSummarySuccess();
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            formData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitBallotSummaryData);
    }

    submitBallotSummaryData() {
        const { actions, formData, userAccountData } = this.props;
        const { callBackUrlPut } = formData;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.upgradeBallotSummaryAccount(this.state, userAccountData, callBackUrlPut);
    }

    displayForm() {
        const {
            isUpgradeSuccessful,
            accountUpgradeMessages,
            purchaseAttemptMessages,
            formData
        } = this.props;

        if (isEmpty(formData)) {
            return null;
        }

        const messagesToDisplay = _isEmpty(accountUpgradeMessages) ? purchaseAttemptMessages : accountUpgradeMessages;

        return (<Fragment>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isUpgradeSuccessful}
                    messages={messagesToDisplay}></FormMessage>
                {this.displayBallotSummaryForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitBallotSummaryFormButtonText}
                ></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayBallotSummaryForm() {
        const { formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, mobilePhone, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        if (this.state[formConstants.dateOfBirth] !== undefined && this.state[formConstants.dateOfBirth] instanceof Date) {
            copyOfFormData[formConstants.dateOfBirth].defaultValue = this.state[formConstants.dateOfBirth];
        }

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target), this.updateFormData); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target), this.updateFormData); },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional), this.updateFormData); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state));
            },
            handleMastercardNumberChange: (event) => {
                this.setState(formStateHelpers.handleMastercardNumberChange(event.target,
                    formData.mastercardRegex, formData.mastercardValidationError));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, formData } = this.props;
        const { formBanner, desktopImageSrc, mobileImageSrc } = formData;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <RegisterFormBanner
                        formBanner={formBanner}
                    ></RegisterFormBanner>
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

BallotSummaryForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    ssoDomain: PropTypes.string,
    formData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        formData: _isEmpty(ownProps.formData) ? state.registerForm.formData : ownProps.formData,
        isUpgradeSuccessful: state.upgradeAccountForm.isUpgradeSuccessful,
        accountUpgradeMessages: state.upgradeAccountForm.accountUpgradeMessages,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress,
        userAccountData: state.userAccount.userAccountData,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            upgradeBallotSummaryAccount: bindActionCreators(upgradeAccountActions.upgradeBallotSummaryAccount, dispatch),
            resetUpgradeAccountFormState: bindActionCreators(upgradeAccountActions.resetUpgradeAccountFormState, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch),
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BallotSummaryForm);
